import useAuth from "./firebase.js";
import alertify from "alertifyjs";

const auth = useAuth();

function handlePasswordReset(evt) {
  evt.preventDefault();
  evt.stopPropagation();
  evt.stopImmediatePropagation();

  const email = document.querySelector(".itp-password-reset input");

  if (email == null || email.value == "") {
    alertify.error("Email must not be empty!");
    return;
  }

  auth.sendPWResetEmail(email.value).then((res) => {
    console.log(res);
    if (res?.hasOwnProperty("error")) {
      alertify.error(res?.error);
      return;
    }

    alertify.success(
      "Check Your email for instructions to reset your password!"
    );
  });
}

export function passwordreset() {
  const btn = document.querySelector("#gform_submit_button_4");

  if (btn != null) {
    btn.onclick = handlePasswordReset;
  }

  const changeBtn = document.querySelector("#gform_submit_button_5");

  if (changeBtn != null) {
    changeBtn.onclick = handlePasswordChange;
  }

  const hash = location.hash.substr(1);

  if (hash != "") {
    // hide top form
    const top1 = document.querySelector(".itp-top-1");
    const top2 = document.querySelector(".itp-top-2");
    const pwform = document.querySelector(".itp-reset-form");

    if (top1 != null && top2 != null && pwform != null) {
      top1.hidden = true;
      top2.hidden = true;
      pwform.hidden = true;
    }

    const code = document.querySelector(".itp-code input");

    if (code != null) {
      code.value = hash;
    }
  }
}

export default {};
